module.exports = __webpack_public_path__ + "static/media/guleli.69952edd.ogg";